import styled from 'styled-components';

import { SafeMotionDiv } from '../../animation/SafeMotionDiv';
import { rem } from '../../helpers';

interface $AccordionContainerProps {
  $naked: boolean;
  $isList?: boolean;
  $withoutMargin?: boolean;
}

export const $AccordionContainer = styled(
  SafeMotionDiv,
)<$AccordionContainerProps>`
  margin-bottom: ${({ $isList, $withoutMargin }) =>
    $isList || $withoutMargin ? 'unset' : '1.25rem'};
  background-color: ${({ theme, $naked }) => {
    return $naked ? null : theme.systemColors.defaultBackground;
  }};

  border-radius: ${({ $isList }) => ($isList ? '0' : rem(5))};
`;

export const $AccordionHeaderContentTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const $AccordionHeaderMinimal = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: relative;

  & button {
    z-index: 10;
  }
`;

export const $Separator = styled.div`
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.newUI.variationColors.light4};
  z-index: 5;
`;
